// @flow
import onSelect from 'slate-on-select';

export default onSelect();
